import * as React from "react"

const Table = React.forwardRef((props, ref) => (
  <div className="relative w-full">
    <table
      ref={ref}
      className={`w-full caption-bottom text-xs ${props.className || ""}`}
      {...props}
    />
  </div>
))
Table.displayName = "Table"

const TableHeader = React.forwardRef((props, ref) => (
  <thead
    ref={ref}
    className={`bg-white z-20 border-gray-300 border-b ${props.className || ""}`}
    {...props}
  />
))

TableHeader.displayName = "TableHeader"

const TableBody = React.forwardRef((props, ref) => (
  <tbody
    ref={ref}
    className={`[&_tr:last-child]:border-0 ${props.className || ""}`}
    {...props}
  />
))
TableBody.displayName = "TableBody"

const TableFooter = React.forwardRef((props, ref) => (
  <tfoot
    ref={ref}
    className={`sticky bottom-0 bg-white bg-muted/50 font-medium [&>tr]:last:border-b-0 ${props.className || ""}`}
    {...props}
  />
))
TableFooter.displayName = "TableFooter"

const TableRow = React.forwardRef((props, ref) => (
  <tr
    ref={ref}
    className={`border-b text-xs transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted ${props.className || ""}`}
    {...props}
  />
))
TableRow.displayName = "TableRow"

const TableHead = React.forwardRef((props, ref) => (
  <th
    ref={ref}
    className={`h-12 px-2 py-2 text-center align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0 ${props.className || ""}`}
    {...props}
  />
))

TableHead.displayName = "TableHead"

const TableCell = React.forwardRef((props, ref) => (
  <td
    ref={ref}
    className={`px-2 py-2 whitespace-nowrap text-center align-middle [&:has([role=checkbox])]:pr-0 ${props.className || ""}`}
    {...props}
  />
))

TableCell.displayName = "TableCell"

const TableCaption = React.forwardRef((props, ref) => (
  <caption
    ref={ref}
    className={`mt-4 text-xs text-muted-foreground ${props.className || ""}`}
    {...props}
  />
))
TableCaption.displayName = "TableCaption"

export {
  Table,
  TableHeader,
  TableBody,
  TableFooter,
  TableHead,
  TableRow,
  TableCell,
  TableCaption,
}
